<template>
    <div class="md-layout" v-cloak>


        <div class="md-layout-item md-medium-size-33 md-small-size-50">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Guidance</md-icon>
                    </div>
                    <h3 class="title">Guidance <b>#<span v-html="guidance.guidance_number"></span></b></h3>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goBack" class="md-primary md-dense">
                            Back to List
                        </md-button>
                    </div>

                </md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Name:</b><span v-html="guidance.name"></span></div>

                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Department:</b><span v-html="guidance.department.name"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Duration:</b><span v-html="guidance.duration"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Guidance Number:</b><span v-html="guidance.guidance_number"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>From: </b><span v-html="guidance.start_date"></span><b>To: </b><span v-html="guidance.end_date"></span></div>
                </div>
                <div class="seperator">
                    <h5><span>Activities</span></h5>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">
                        <b>Total Number of Activities</b>
                        <span v-html="guidance.activities_count"></span>
                    </div>
                    <md-button
                            class="md-primary md-round classic-modal"
                            @click="modal.classicModal = true"
                    >Add Activity</md-button
                    >
                </div>
                <div class="seperator">
                    <h5><span>Status</span></h5>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">
                        Preparation:
                    </div>
                    <div class="md-layout-item">
                        Reviw:
                    </div>
                    <div class="md-layout-item">
                        Approval level 1:
                    </div>
                    <div class="md-layout-item">
                        Approval level 2:
                    </div>

                </div>

                <modal v-if="modal.classicModal" @close="classicModalHide">
                    <template slot="header">
                        <h4 class="modal-title">Modal Title</h4>
                        <md-button
                                class="md-simple md-just-icon md-round modal-default-button"
                                @click="classicModalHide"
                        >
                            <md-icon>clear</md-icon>
                        </md-button>
                    </template>

                    <template slot="body">
                        <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
                            <iframe class="embed-responsive-item" src="http://localhost:8080/settings/add-guidance" allowfullscreen></iframe>
                        </div>
                    </template>

                    <template slot="footer">
                        <md-button class="md-simple">Nice Button</md-button>
                        <md-button
                                class="md-danger md-simple"
                                @click="classicModalHide"
                        >Close</md-button
                        >
                    </template>
                </modal>
            </md-card>
        </div>
            <div class="md-layout-item md-medium-size-33 md-small-size-50">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Guidance Activities</md-icon>
                    </div>
                    <h4 class="title">Guidance Activities</h4>
                </md-card-header>
                <md-card-content>
                </md-card-content>
            </md-card>
        </div>
    </div>

</template>

<script>
import { Modal } from '@/components';
export default {
    components: {
        Modal
    },
    props: {
        registerImg: {
            type: String,
            default: process.env.VUE_APP_BASE_URL + '/img/card-1.jpg'
        },
        applyImg: {
            type: String,
            default: process.env.VUE_APP_BASE_URL + '/img/card-2.jpg'
        }
    },
    data: () => ({
        guidance: {
            type: 'guidances',
            name: null,
            guidance_number: null,
            duration: null,
            start_date: null,
            end_date: null,
            department: {
                id: null,
                type: 'departments',
            },
            relationshipNames: ['department'],
        },
        available_departments: [],

        modal:{
            type: ['', 'info', 'success', 'warning', 'danger'],
            notifications: {
                topCenter: false
            },
            classicModal: false,
            noticeModal: false,
            smallAlertModal: false,
            src: '',
        }
    }),

    created () {
        this.get();
        this.getDepartments();
    },

    methods: {
        closeModal: function () {
            this.$emit('close');
        },
        async get () {
            try {
                const id = this.$route.params.id;
                console.log(id);
                await this.$store.dispatch('guidances/get', id);
                this.guidance = this.$store.getters['guidances/guidance'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        getDepartments () {
            this.$store.dispatch('departments/list').then(() => {
                this.available_departments = this.$store.getters['departments/dropdown'];
            });
        },
        goBack () {
            this.$router.push({ name: 'Guidances List' });
        },

        notifyVue (verticalAlign, horizontalAlign) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
                timeout: 2500,
                message:
                        'Welcome to <b>Vibarua eSystem</b> - a beautiful system panel for every web developer.',
                icon: 'add_alert',
                horizontalAlign: horizontalAlign,
                verticalAlign: verticalAlign,
                type: this.modal.type[color]
            });
        },
        classicModalHide: function () {
            this.modal.classicModal = false;
        },
        noticeModalHide: function () {
            this.modal.noticeModal = false;
        },
        smallAlertModalHide: function () {
            this.modal.smallAlertModal = false;
        }
    },
};

</script>

<style lang="scss" scoped>
    modal{
        maxWidth: 100% !important;

    }
    .modal-container {
        max-width: 100% !important;
    }
.seperator h5 {
display: flex;
justify-content: center;
align-items: center;
padding: 0 1em;
}
.seperator h5::before,
.seperator h5::after {
content: "";
display: block;
flex-grow: 1;
height: 1px;
background: #ccc;
}
.seperator h5 span {
padding: 0 2em;
}

.text-center {
    text-align: center;
}

.places-buttons + div .md-button:not(:last-child) {
    margin-right: 1px;
}
</style>
